export default __webpack_public_path__ + "static/media/logo.9142f2af.png";